import {
  EKybStatus,
  EKYCStatus,
  partnerAdditionalOwnerSchema,
  schemes,
  zSchema,
} from "@zeal/common";

export const updatePartnerInfoRequestSchema = zSchema.object({
  whiteLabelID: schemes.uuid(),
  business_name: zSchema.string().optional(),
  dba: zSchema.string().optional(),
  business_description: zSchema.string().optional(),
  legal_structure: zSchema.string().optional(),
  business_ein: zSchema.string().optional(),
  business_address: zSchema.string().optional(),
  business_address_line2: zSchema.string().optional(),
  business_city: zSchema.string().optional(),
  business_state: zSchema.string().optional(),
  business_zip: zSchema.string().optional(),
  business_phone: zSchema.string().optional(),
  business_email: zSchema.string().optional(),
  is_mailing_address_different: zSchema.boolean().optional(),
  mail_address: zSchema.string().optional(),
  mail_address_line2: zSchema.string().optional(),
  mail_city: zSchema.string().optional(),
  mail_state: zSchema.string().optional(),
  mail_zip: zSchema.string().optional(),
  is_physical_address_different: zSchema.boolean().optional(),
  physical_address: zSchema.string().optional(),
  physical_address_line2: zSchema.string().optional(),
  physical_city: zSchema.string().optional(),
  physical_state: zSchema.string().optional(),
  physical_zip: zSchema.string().optional(),
  business_owner_first_name: zSchema.string().optional(),
  business_owner_last_name: zSchema.string().optional(),
  ownership_percentage: zSchema.number().int().min(0).max(100).optional(),
  owner_email: zSchema.string().optional(),
  owner_address: zSchema.string().optional(),
  owner_addressLine2: zSchema.string().optional(),
  owner_city: zSchema.string().optional(),
  owner_state: zSchema.string().optional(),
  owner_zip: zSchema.string().optional(),
  ssn: zSchema.string().optional(),
  dob: zSchema.string().optional(),
  job_title: zSchema.string().optional(),
  additionalOwners: zSchema.array(partnerAdditionalOwnerSchema).optional(),
  hasAdditionalOwners: zSchema.boolean().optional(),
  kyb_status: zSchema.nativeEnum(EKybStatus).optional(),
  business_owner_kyc_status: zSchema
    .nativeEnum(EKYCStatus)
    .nullable()
    .optional(),
});

export type TUpdatePartnerInfoRequest = zSchema.infer<
  typeof updatePartnerInfoRequestSchema
>;

export type TUpdatePartnerInfoResponse = zSchema.infer<
  typeof updatePartnerInfoRequestSchema
>;
